import { createApi } from '@reduxjs/toolkit/query/react';
import customFetchBase from '@/shared/api/customFetchBase';

export const rtkApi = createApi({
  reducerPath: 'api',
  baseQuery: customFetchBase,
  tagTypes: [
    'Profile',
    'UsualTable',
    'ClubTable',
    'UserLog',
    'ClubLog',
    'ClubBalance',
    'GameBuilds',
    'Teams',
    'MaxBindings',
    'News',
    'PushProviders',
    'BillingTariffs',
  ],
  endpoints: () => ({}),
});
